import api from './api';

const draftService = {
  async listDrafts() {
    const response = await api.get('/api/drafts');
    return response.data;
  },

  async upsertPostDraft(payload) {
    const response = await api.post('/api/drafts/posts', payload);
    return response.data;
  },

  async publishPostDraft(id) {
    const response = await api.post(`/api/drafts/posts/${id}/publish`);
    return response.data;
  },

  async deletePostDraft(id) {
    const response = await api.delete(`/api/drafts/posts/${id}`);
    return response.data;
  },

  async upsertThreadDraft(payload) {
    const response = await api.post('/api/drafts/threads', payload);
    return response.data;
  },

  async publishThreadDraft(id) {
    const response = await api.post(`/api/drafts/threads/${id}/publish`);
    return response.data;
  },

  async deleteThreadDraft(id) {
    const response = await api.delete(`/api/drafts/threads/${id}`);
    return response.data;
  },
};

export default draftService;

export function hasSubstantialHtml(html) {
  if (!html) return false;
  const container = document.createElement('div');
  container.innerHTML = html;
  const text = (container.textContent || '').replace(/\u00a0/g, ' ').trim();
  return text.length > 0;
}
